import { render, staticRenderFns } from "./AcuerdoDistribucionTab.vue?vue&type=template&id=7bc114c6&"
import script from "./AcuerdoDistribucionTab.vue?vue&type=script&lang=js&"
export * from "./AcuerdoDistribucionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports